"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tooltip = exports.Separator = exports.LimitPriceMessagePortal = exports.LimitPriceMessage = exports.LimitPriceMessageContent = exports.ShowConfirmation = exports.PanelWarning = exports.MarketPriceWarning = exports.DstToken = exports.SrcToken = exports.CopyTokenAddress = exports.TradeSize = exports.TradeSizeValue = exports.PoweredBy = exports.TokenUSD = exports.TokenBalance = exports.ChunksUSD = exports.TokenSelectModal = exports.TradeIntervalSelector = exports.TokenSymbol = exports.TokenSelect = exports.TokenLogoAndSymbol = exports.TokenLogo = exports.TokenPanelInput = exports.ChangeTokensOrder = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var base_1 = require("./base");
var Message_1 = require("./base/Message");
var context_1 = require("../context/context");
var RiArrowUpDownLine_1 = require("@react-icons/all-files/ri/RiArrowUpDownLine");
var styled_components_1 = __importDefault(require("styled-components"));
var hooks_1 = require("../hooks/hooks");
var useConfirmationButton_1 = require("../hooks/useConfirmationButton");
var styles_1 = require("../styles");
var TokenDisplay_1 = __importDefault(require("./base/TokenDisplay"));
var Labels_1 = require("./Labels");
var Copy_1 = __importDefault(require("./base/Copy"));
var config_1 = require("../config");
var __1 = require("..");
var IoIosArrowDown_1 = require("@react-icons/all-files/io/IoIosArrowDown");
var actions_1 = require("../context/actions");
var lib_1 = require("../hooks/lib");
var ChangeTokensOrder = function (_a) {
    var children = _a.children, _b = _a.className, className = _b === void 0 ? "" : _b, _c = _a.icon, icon = _c === void 0 ? (0, jsx_runtime_1.jsx)(RiArrowUpDownLine_1.RiArrowUpDownLine, {}) : _c;
    var switchTokens = (0, lib_1.useSwitchTokens)();
    return ((0, jsx_runtime_1.jsx)(StyledChangeTokens, __assign({ className: "".concat(className, " twap-change-tokens-order") }, { children: (0, jsx_runtime_1.jsx)("button", __assign({ onClick: switchTokens }, { children: children || (0, jsx_runtime_1.jsx)(base_1.Icon, { icon: icon }) })) })));
};
exports.ChangeTokensOrder = ChangeTokensOrder;
var StyledChangeTokens = (0, styled_components_1.default)(styles_1.StyledRowFlex)({
    button: {
        padding: 0,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },
});
var Input = function (props) {
    return ((0, jsx_runtime_1.jsx)(base_1.NumericInput, { className: "".concat(props.className, " twap-token-input ").concat(props.loading ? "twap-token-input-loading" : ""), decimalScale: props.decimalScale, prefix: props.prefix, loading: props.loading, disabled: props.disabled, placeholder: props.placeholder, onChange: function (value) { var _a; return (_a = props.onChange) === null || _a === void 0 ? void 0 : _a.call(props, value); }, value: props.value }));
};
var TokenPanelInput = function (_a) {
    var isSrc = _a.isSrc, placeholder = _a.placeholder, _b = _a.className, className = _b === void 0 ? "" : _b, dstDecimalScale = _a.dstDecimalScale;
    if (isSrc) {
        return (0, jsx_runtime_1.jsx)(SrcTokenInput, { className: className, placeholder: placeholder });
    }
    return (0, jsx_runtime_1.jsx)(DstTokenInput, { decimalScale: dstDecimalScale, className: className, placeholder: placeholder });
};
exports.TokenPanelInput = TokenPanelInput;
var SrcTokenInput = function (props) {
    var srcToken = (0, context_1.useTwapContext)().srcToken;
    var srcAmountUi = (0, lib_1.useSrcAmount)().amountUi;
    var onChange = actions_1.stateActions.useSetSrcAmount();
    return (0, jsx_runtime_1.jsx)(Input, { prefix: "", onChange: onChange, value: srcAmountUi || "", decimalScale: srcToken === null || srcToken === void 0 ? void 0 : srcToken.decimals, className: props.className, placeholder: props.placeholder });
};
var DstTokenInput = function (props) {
    var token = (0, context_1.useTwapContext)().dstToken;
    var _a = (0, lib_1.useOutAmount)(), amountUi = _a.amountUi, isLoading = _a.isLoading;
    var isMarketOrder = (0, lib_1.useIsMarketOrder)();
    return ((0, jsx_runtime_1.jsx)(Input, { disabled: true, loading: isLoading, prefix: isMarketOrder ? config_1.SQUIGLE : "", value: (0, hooks_1.useFormatDecimals)(amountUi), decimalScale: props.decimalScale || (token === null || token === void 0 ? void 0 : token.decimals), className: props.className, placeholder: props.placeholder }));
};
var TokenLogo = function (_a) {
    var isSrc = _a.isSrc, _b = _a.className, className = _b === void 0 ? "" : _b;
    var token = (0, lib_1.useToken)(isSrc);
    return (0, jsx_runtime_1.jsx)(base_1.TokenLogo, { className: className, logo: token === null || token === void 0 ? void 0 : token.logoUrl });
};
exports.TokenLogo = TokenLogo;
function TokenLogoAndSymbol(_a) {
    var isSrc = _a.isSrc, reverse = _a.reverse;
    var token = (0, lib_1.useToken)(isSrc);
    return (0, jsx_runtime_1.jsx)(TokenDisplay_1.default, { reverse: reverse, logo: token === null || token === void 0 ? void 0 : token.logoUrl, symbol: token === null || token === void 0 ? void 0 : token.symbol });
}
exports.TokenLogoAndSymbol = TokenLogoAndSymbol;
var TokenSelect = function (_a) {
    var onClick = _a.onClick, isSrc = _a.isSrc, _b = _a.hideArrow, hideArrow = _b === void 0 ? true : _b, _c = _a.className, className = _c === void 0 ? "" : _c, CustomArrow = _a.CustomArrow, customButtonElement = _a.customButtonElement;
    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "".concat(className, " twap-token-select"), onClick: onClick, style: { cursor: "pointer" } }, { children: (0, jsx_runtime_1.jsxs)(styles_1.StyledRowFlex, __assign({ gap: 5, style: { cursor: "pointer" }, width: "fit-content", className: "twap-token-selected" }, { children: [(0, jsx_runtime_1.jsx)(TokenLogoAndSymbol, { isSrc: isSrc }), !hideArrow && (0, jsx_runtime_1.jsx)(base_1.Icon, { icon: CustomArrow ? (0, jsx_runtime_1.jsx)(CustomArrow, { size: 20 }) : (0, jsx_runtime_1.jsx)(IoIosArrowDown_1.IoIosArrowDown, { size: 20 }) })] })) })));
};
exports.TokenSelect = TokenSelect;
var TokenSymbol = function (_a) {
    var isSrc = _a.isSrc, hideNull = _a.hideNull, onClick = _a.onClick;
    var token = (0, lib_1.useToken)(isSrc);
    return (0, jsx_runtime_1.jsx)(base_1.TokenName, { onClick: onClick, hideNull: hideNull, name: token === null || token === void 0 ? void 0 : token.symbol });
};
exports.TokenSymbol = TokenSymbol;
function TradeIntervalSelector(_a) {
    var placeholder = _a.placeholder;
    var setFillDelay = actions_1.stateActions.useSetCustomFillDelay();
    var fillDelay = (0, context_1.useTwapContext)().state.customFillDelay;
    return (0, jsx_runtime_1.jsx)(base_1.TimeSelector, { placeholder: placeholder, onChange: setFillDelay, value: fillDelay });
}
exports.TradeIntervalSelector = TradeIntervalSelector;
var TokenSelectModal = function (_a) {
    var Component = _a.Component, isOpen = _a.isOpen, onClose = _a.onClose, _b = _a.isSrc, isSrc = _b === void 0 ? false : _b;
    var onTokenSelectedCallback = (0, lib_1.useTokenSelect)();
    var onSelect = (0, react_1.useCallback)(function (token) {
        onTokenSelectedCallback({ isSrc: isSrc, token: token });
        onClose();
    }, [onTokenSelectedCallback, isSrc]);
    if (!Component)
        return null;
    return (0, jsx_runtime_1.jsx)(Component, { isSrc: isSrc, isOpen: isOpen, onClose: onClose, onSelect: onSelect, srcTokenSelected: undefined, dstTokenSelected: undefined });
};
exports.TokenSelectModal = TokenSelectModal;
function ChunksUSD(_a) {
    var onlyValue = _a.onlyValue, emptyUi = _a.emptyUi, suffix = _a.suffix, prefix = _a.prefix;
    var usd = (0, lib_1.useSrcChunkAmountUsd)();
    return (0, jsx_runtime_1.jsx)(base_1.USD, { prefix: prefix, suffix: suffix, value: usd, onlyValue: onlyValue, emptyUi: emptyUi, isLoading: !usd });
}
exports.ChunksUSD = ChunksUSD;
var TokenBalance = function (_a) {
    var _b, _c;
    var isSrc = _a.isSrc, label = _a.label, showSymbol = _a.showSymbol, _d = _a.className, className = _d === void 0 ? "" : _d, hideLabel = _a.hideLabel, emptyUi = _a.emptyUi, decimalScale = _a.decimalScale;
    var _e = (0, context_1.useTwapContext)(), srcToken = _e.srcToken, dstToken = _e.dstToken;
    var symbol = isSrc ? srcToken === null || srcToken === void 0 ? void 0 : srcToken.symbol : dstToken === null || dstToken === void 0 ? void 0 : dstToken.symbol;
    var suffix = !showSymbol ? undefined : isSrc ? srcToken === null || srcToken === void 0 ? void 0 : srcToken.symbol : dstToken === null || dstToken === void 0 ? void 0 : dstToken.symbol;
    var srcBalance = (0, hooks_1.useAmountUi)(srcToken === null || srcToken === void 0 ? void 0 : srcToken.decimals, (_b = (0, hooks_1.useSrcBalance)().data) === null || _b === void 0 ? void 0 : _b.toString());
    var dstBalance = (0, hooks_1.useAmountUi)(dstToken === null || dstToken === void 0 ? void 0 : dstToken.decimals, (_c = (0, hooks_1.useDstBalance)().data) === null || _c === void 0 ? void 0 : _c.toString());
    var balance = isSrc ? srcBalance : dstBalance;
    return ((0, jsx_runtime_1.jsx)(base_1.Balance, { symbol: symbol || "", decimalScale: decimalScale, emptyUi: emptyUi, hideLabel: hideLabel, className: className, suffix: suffix, label: label, value: balance, isLoading: !balance }));
};
exports.TokenBalance = TokenBalance;
function TokenUSD(_a) {
    var isSrc = _a.isSrc, emptyUi = _a.emptyUi, _b = _a.className, className = _b === void 0 ? "" : _b, onlyValue = _a.onlyValue, prefix = _a.prefix, suffix = _a.suffix, hideIfZero = _a.hideIfZero, decimalScale = _a.decimalScale;
    var _c = (0, lib_1.useUsdAmount)(), srcUsd = _c.srcUsd, dstUsd = _c.dstUsd;
    var usd = isSrc ? srcUsd : dstUsd;
    if (Number(usd) <= 0 && hideIfZero)
        return null;
    return (0, jsx_runtime_1.jsx)(base_1.USD, { decimalScale: decimalScale, suffix: suffix, prefix: prefix, onlyValue: onlyValue, className: className, emptyUi: emptyUi, value: usd || "0", isLoading: !usd });
}
exports.TokenUSD = TokenUSD;
function PoweredBy(_a) {
    var _b = _a.className, className = _b === void 0 ? "" : _b;
    var translations = (0, context_1.useTwapContext)().translations;
    return ((0, jsx_runtime_1.jsx)(StyledPoweredBy, __assign({ className: "".concat(className, " twap-powered-by") }, { children: (0, jsx_runtime_1.jsxs)("a", __assign({ href: "https://www.orbs.com/", target: "_blank" }, { children: [(0, jsx_runtime_1.jsx)(styles_1.StyledText, { children: translations.poweredBy }), (0, jsx_runtime_1.jsx)("img", { src: "https://raw.githubusercontent.com/orbs-network/twap-ui/master/logo/orbslogo.svg" })] })) })));
}
exports.PoweredBy = PoweredBy;
var StyledPoweredBy = (0, styled_components_1.default)(styles_1.StyledRowFlex)({
    marginTop: 10,
    marginBottom: 10,
    "& p": {
        color: "inherit",
    },
    "& a": {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        textDecoration: "unset",
        gap: 8,
    },
    "& img": {
        width: 20,
        height: 20,
        objectFit: "contain",
    },
});
var TradeSizeValue = function (_a) {
    var symbol = _a.symbol;
    var value = (0, lib_1.useSrcChunkAmount)().amountUi;
    var formattedValue = (0, hooks_1.useFormatNumber)({ value: value });
    var _b = (0, context_1.useTwapContext)(), srcToken = _b.srcToken, Components = _b.Components;
    var formattedValueTooltip = (0, hooks_1.useFormatNumber)({ value: value, decimalScale: 18 });
    if (!formattedValue || formattedValue === "0") {
        return (0, jsx_runtime_1.jsx)("p", __assign({ className: "twap-trade-size-value" }, { children: "-" }));
    }
    var content = (0, jsx_runtime_1.jsx)("p", __assign({ className: "twap-trade-size-value" }, { children: "".concat(symbol ? "".concat(formattedValue, " ").concat(srcToken === null || srcToken === void 0 ? void 0 : srcToken.symbol) : formattedValue) }));
    if (!(Components === null || Components === void 0 ? void 0 : Components.Tooltip))
        return content;
    return (0, jsx_runtime_1.jsx)(Components.Tooltip, __assign({ tooltipText: "".concat(symbol ? "".concat(formattedValueTooltip, " ").concat(srcToken === null || srcToken === void 0 ? void 0 : srcToken.symbol) : formattedValueTooltip) }, { children: content }));
};
exports.TradeSizeValue = TradeSizeValue;
var TradeSize = function (_a) {
    var hideLabel = _a.hideLabel, hideSymbol = _a.hideSymbol, hideLogo = _a.hideLogo;
    var _b = (0, context_1.useTwapContext)(), srcToken = _b.srcToken, dstToken = _b.dstToken;
    if (!srcToken && !dstToken) {
        return (0, jsx_runtime_1.jsx)("span", { children: "0" });
    }
    if (!srcToken && !hideLabel) {
        return (0, jsx_runtime_1.jsx)(Labels_1.ChunksAmountLabel, {});
    }
    return ((0, jsx_runtime_1.jsxs)(StyledTradeSize, { children: [!hideLabel && (0, jsx_runtime_1.jsx)(Labels_1.ChunksAmountLabel, {}), (0, jsx_runtime_1.jsxs)(styles_1.StyledRowFlex, __assign({ gap: 7, className: "content" }, { children: [!hideLogo && (0, jsx_runtime_1.jsx)(exports.TokenLogo, { isSrc: true }), (0, jsx_runtime_1.jsx)(exports.TradeSizeValue, { symbol: !hideSymbol })] }))] }));
};
exports.TradeSize = TradeSize;
var StyledTradeSize = (0, styled_components_1.default)(styles_1.StyledRowFlex)(__assign(__assign({ width: "auto", gap: 10 }, styles_1.textOverflow), { minWidth: 0, ".content": {
        ".twap-token-logo": {
            width: 21,
            height: 21,
        },
        ".value": __assign({}, styles_1.textOverflow),
        p: {
            paddingTop: 2,
        },
        "*": {
            fontFamily: "inherit",
            fontSize: 14,
        },
    }, ".twap-label": {
        whiteSpace: "nowrap",
    } }));
var CopyTokenAddress = function (_a) {
    var isSrc = _a.isSrc;
    var _b = (0, context_1.useTwapContext)(), srcToken = _b.srcToken, dstToken = _b.dstToken;
    var address = isSrc ? srcToken === null || srcToken === void 0 ? void 0 : srcToken.address : dstToken === null || dstToken === void 0 ? void 0 : dstToken.address;
    return (0, jsx_runtime_1.jsx)(Copy_1.default, { value: address });
};
exports.CopyTokenAddress = CopyTokenAddress;
var SrcToken = function () {
    return ((0, jsx_runtime_1.jsxs)(__1.Styles.StyledRowFlex, __assign({ style: { width: "auto" } }, { children: [(0, jsx_runtime_1.jsx)(exports.TokenLogo, { isSrc: true }), (0, jsx_runtime_1.jsx)(exports.TokenSymbol, { isSrc: true })] })));
};
exports.SrcToken = SrcToken;
var DstToken = function () {
    return ((0, jsx_runtime_1.jsxs)(__1.Styles.StyledRowFlex, __assign({ style: { width: "auto" } }, { children: [(0, jsx_runtime_1.jsx)(exports.TokenLogo, {}), (0, jsx_runtime_1.jsx)(exports.TokenSymbol, {})] })));
};
exports.DstToken = DstToken;
var MarketPriceWarning = function (_a) {
    var _b = _a.className, className = _b === void 0 ? "" : _b;
    var isMarketOrder = (0, lib_1.useIsMarketOrder)();
    var t = (0, context_1.useTwapContext)().translations;
    var isWrapOrUnwrapOnly = (0, lib_1.useShouldWrapOrUnwrapOnly)();
    if (!isMarketOrder || isWrapOrUnwrapOnly)
        return null;
    return ((0, jsx_runtime_1.jsx)(Message_1.Message, { className: "twap-market-price-warning ".concat(className), title: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [t === null || t === void 0 ? void 0 : t.marketOrderWarning, (0, jsx_runtime_1.jsx)("a", __assign({ href: "https://www.orbs.com/dtwap-and-dlimit-faq/", target: "_blank" }, { children: " ".concat(t.learnMore) }))] }), variant: "warning" }));
};
exports.MarketPriceWarning = MarketPriceWarning;
var PanelWarning = function (_a) {
    var _b = _a.className, className = _b === void 0 ? "" : _b;
    var feeOnTranferWarning = (0, lib_1.useFeeOnTransferWarning)();
    var lowPriceWarning = (0, lib_1.useLowPriceWarning)();
    var isWrapOrUnwrapOnly = (0, lib_1.useShouldWrapOrUnwrapOnly)();
    var isWrongChain = (0, context_1.useTwapContext)().isWrongChain;
    var show = feeOnTranferWarning || lowPriceWarning;
    var title = feeOnTranferWarning || (lowPriceWarning === null || lowPriceWarning === void 0 ? void 0 : lowPriceWarning.title);
    var text = lowPriceWarning === null || lowPriceWarning === void 0 ? void 0 : lowPriceWarning.subTitle;
    if (!show || isWrapOrUnwrapOnly || isWrongChain)
        return null;
    return (0, jsx_runtime_1.jsx)(Message_1.Message, { className: className, title: title, text: text, variant: "error" });
};
exports.PanelWarning = PanelWarning;
var ShowConfirmation = function (_a) {
    var _b = _a.className, className = _b === void 0 ? "" : _b, connect = _a.connect;
    var _c = (0, useConfirmationButton_1.useConfirmationButton)(connect), onClick = _c.onClick, text = _c.text, disabled = _c.disabled, loading = _c.loading;
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsxs)(StyledShowConfirmation, __assign({ className: className }, { children: [(0, jsx_runtime_1.jsx)(exports.PanelWarning, {}), (0, jsx_runtime_1.jsx)(base_1.Button, __assign({ className: "twap-submit-button", allowClickWhileLoading: true, onClick: onClick ? onClick : function () { }, loading: loading, disabled: disabled }, { children: text }))] })) }));
};
exports.ShowConfirmation = ShowConfirmation;
var StyledShowConfirmation = (0, styled_components_1.default)(styles_1.StyledColumnFlex)({
    gap: 20,
});
var LimitPriceMessageContent = function (_a) {
    var className = _a.className;
    return ((0, jsx_runtime_1.jsx)(base_1.Portal, __assign({ containerId: "twap-limit-price-message-container" }, { children: (0, jsx_runtime_1.jsx)(exports.LimitPriceMessage, { className: className }) })));
};
exports.LimitPriceMessageContent = LimitPriceMessageContent;
var LimitPriceMessage = function (_a) {
    var className = _a.className;
    var t = (0, context_1.useTwapContext)().translations;
    var isMarketOrder = (0, lib_1.useIsMarketOrder)();
    var isWrapOrUnwrapOnly = (0, lib_1.useShouldWrapOrUnwrapOnly)();
    if (isMarketOrder || isWrapOrUnwrapOnly)
        return null;
    return ((0, jsx_runtime_1.jsx)(StyledLimitPriceMessage, { className: "".concat(className, " twap-limit-price-message"), variant: "warning", title: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [t.limitPriceMessage, " ", (0, jsx_runtime_1.jsx)("a", __assign({ href: "https://www.orbs.com/dtwap-and-dlimit-faq/", target: "_blank" }, { children: t.learnMore }))] }) }));
};
exports.LimitPriceMessage = LimitPriceMessage;
var LimitPriceMessagePortal = function () {
    return (0, jsx_runtime_1.jsx)("div", { id: "twap-limit-price-message-container" });
};
exports.LimitPriceMessagePortal = LimitPriceMessagePortal;
var StyledLimitPriceMessage = (0, styled_components_1.default)(Message_1.Message)({
    color: "white",
});
var Separator = function (_a) {
    var _b = _a.className, className = _b === void 0 ? "" : _b;
    return (0, jsx_runtime_1.jsx)(StyledSeparator, { className: "".concat(className, " twap-separator") });
};
exports.Separator = Separator;
var StyledSeparator = (0, styled_components_1.default)("div")({
    width: "100%",
    height: "1px",
});
var Tooltip = function (props) {
    var Components = (0, context_1.useTwapContext)().Components;
    if (!(Components === null || Components === void 0 ? void 0 : Components.Tooltip)) {
        return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: props.children });
    }
    return (0, jsx_runtime_1.jsx)(Components.Tooltip, __assign({}, props));
};
exports.Tooltip = Tooltip;
